window.globals = function globals() {};
globals.isDevice;
globals.isHighDensity;

if(/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent)
    || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0,4))) {
    globals.isDevice = true;
}
// Pixel Density Detection
if ((window.matchMedia && (window.matchMedia('only screen and (min-resolution: 124dpi), only screen and (min-resolution: 1.3dppx), only screen and (min-resolution: 48.8dpcm)').matches || window.matchMedia('only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (min-device-pixel-ratio: 1.3)').matches)) || (window.devicePixelRatio && window.devicePixelRatio > 1.3)) {
  globals.isHighDensity = true;
}

globals.detectProduction = function() {
  if (
    window.location.href.indexOf('www.graberblinds.com') !== -1 ||
    window.location.href.indexOf('https://graberblinds.com') !== -1 ||
    window.location.href.indexOf('http://graberblinds.com') !== -1
  ) {
    return true;
  }
  return false;
}
globals.isProduction = globals.detectProduction();

globals.getParameterByName = function (name, url) {
  if (!url) url = window.location.href;
  name = name.replace(/[\[\]]/g, '\\$&');
  var regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)');
  var results = regex.exec(url);
  if (!results) return null;
  if (!results[2]) return '';
  return decodeURIComponent(results[2].replace(/\+/g, ' '));
};

/*

  LOCAL STORAGE

*/
window.ls = function ls() {};

ls.cookies = {
  swbk: {
    name: 'grbr_favorites',
    expriy: 0
  },
  promo: {
    name: 'grbr_promo',
    expiry: 0
  },
  loc: {
    name: 'grbr_dealer',
    expiry: 0
  },
  ordinfo: {
    name: 'grbr_ordinfo',
    expiry: 0
  }
}

ls.localStorageCheck = function() {
  var ls = 'ls';
  try {
    window.localStorage.setItem(ls, ls);
    window.localStorage.removeItem(ls);
    return true;
  } catch(e) {
    return false;
  }
}

ls.setItemInObj = function(cookie, data) {
  var val = JSON.stringify(data);
  if (ls.isLocalStorage) {
    window.localStorage.setItem(cookie.name, val);
  } else {
    var exdate = new Date();
    exdate.setDate(exdate.getDate() + cookie.expriy);
    val = escape(val) + ((cookie.expriy == null) ? '' : '; expires='+ exdate.toUTCString());
    document.cookie = cookie.name + '=' + val;
  }
};

ls.getItemFromObj = function(cookie) {
  var data;
  if (ls.isLocalStorage) {
    data = window.localStorage.getItem(cookie.name);
  } else {
    data = document.cookie.toString().match(new RegExp(cookie.name, 'gi'));
  }
  return JSON.parse(data);
};

ls.deleteItem = function(cookie) {
  if (ls.isLocalStorage) {
    window.localStorage.removeItem(cookie.name);
  } else {
    document.cookie = cookie.name + '=; Path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
  }
}

/*

  PROMO

*/
window.dismissPromo = function() {
  // ls.setItemInObj(ls.cookies.promo, {dismissed: true});
  window.sessionStorage.setItem('grbr_promo', JSON.stringify({dismissed: true}));
};

window.promoDisplayCheck = function(callback) {
  // var data = ls.getItemFromObj(ls.cookies.promo);
  var data = window.sessionStorage.getItem('grbr_promo');
  if (data !== null) {
    data = JSON.parse(data);
    if (data.dismissed) {
      if (callback !== undefined) {
        callback();
      }
    }
  }
};
